const { createSlice } = require('@reduxjs/toolkit')
const searchCards = []
const SearchCards = createSlice({
  name: 'SearchCards',
  initialState: searchCards,
  reducers: {
    setSearchCards: (state, action) => {
        console.log(
            "action redux :",action
        )
      // state = action.payload
    }
  }
})

export const { setSearchCards } = SearchCards.actions;
export default SearchCards.reducer;